import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { BlahService } from '@headpower/blah-ng';


export class IwmLocale {
  language: string;
  country: string;
  full: string;

  constructor(language: string, country: string) {
    this.language = language;
    this.country = country;
    this.full = language + '-' + country;
  }
}

/**
 * Service to return always up-to-date locale consisting of language (from Blah)
 * and country (from claims)
 */
@Injectable({
  providedIn: 'root'
})
export class IwmLocaleService {

  public iwmLocale$: BehaviorSubject<IwmLocale> = new BehaviorSubject<IwmLocale>(undefined);

  constructor(private blahService: BlahService, private oauthService: OAuthService) { }

  public setLocale(): void {
    const claims: any = this.oauthService.getIdentityClaims();

    const claimsLocale = claims['locale'];
    let index = claimsLocale.indexOf('-');
    const country: string = index !== -1 ? claimsLocale.slice(index + 1, claimsLocale.length) : 'FI';

    const blahLocale = this.blahService.currentLocale;
    index = blahLocale.indexOf('-');
    const language: string = index !== -1 ? blahLocale.slice(0, index) : blahLocale;

    this.iwmLocale$.next(new IwmLocale(language, country));
  }

  /**
   * Returns current value, can be used if observable stream is not needed
   */
  public getLocale(): IwmLocale {
    return this.iwmLocale$.value;
  }
}
